export default "__VITE_ASSET__Bz7hX5Uy__"